const webhookContentTypes = [
    {
        id: 'email',
        name: 'Email'
    }, 
    {
        id: 'phone',
        name: 'Phone'
    }, 
    {
        id: 'url',
        name: 'URL'
    }
]

export default webhookContentTypes